// action creator is just a function that dispatch an action
// we need to create an action and dispatch it here
// action is an object with the type of deposit

// First action creator
export const depositMoney = (amount) => {
    return (dispatch) => {
        dispatch({
            type: 'deposit',
            payload: amount
        })
    }
}

export const withdraw = (amount) => {
    return (dispatch) => {
        dispatch({
            type: 'draw',
            payload: amount
        })
    }
}